import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ConfigurationCommitmentsService } from '../configuration-commitments.service';
import { ConfigurationCommitmentsCommitmentsViewPart } from './commitments/commitments-view.part';
@Component({
	selector: 'configuration-commitments-views-part',
	standalone: true,
	imports: [
		ConfigurationCommitmentsCommitmentsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './commitments-views.part.html',
})
export class ConfigurationCommitmentsViewsPart implements OnInit {
	public service = inject(ConfigurationCommitmentsService);

	ngOnInit() {
		this.service.initializeUrl();
	}

}